import { jwtDecode } from "jwt-decode";
import axios from "axios";
export const fetchNotificationSettings = () => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);
  dispatch({ type: "FETCH_NOTIFICATION_LOADING" });
  try {
    const url = `${process.env.REACT_APP_API_URL}/getProfileDetails?userGuid=${decodedToken.userGuid}`;
    const response = await axios({
      method: "GET",
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
        const preferenceData = {};
        const fieldMapping = {
          preferedLang: "preferedLang",
          timezone: "timezone",
        };

        Object.keys(fieldMapping).forEach((formField) => {
          const apiField = fieldMapping[formField];
          if (
            response.data[apiField] !== null &&
            response.data[apiField] !== undefined
          ) {
            preferenceData[formField] = response.data[apiField];
          }
        });
        const data = {
          notificationChannel:response.data.notificationChannel,
          preferenceData:preferenceData
        }
        //console.log(preferenceData,"operewwp")
        dispatch({
            type: "NOTIFICATION_DATA_SUCCESS",
            payload: data,
          });
      }
 
  } catch (error) {
    //console.error("Error fetching notification settings:", error);
  }
};
export const overRideNotifications = (index) => async (dispatch) => {
  dispatch({
    type: "OVERRIDE_NOTIFICATION",
    payload: index,
  });
};
export const updateNotificationSettings = (formData, notificationChannel) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  const decodedToken = jwtDecode(token);

  dispatch({ type: "UPDATE_NOTIFICATION_LOADING" });

  try {
    const formDataToSend = {
      notificationChannel,
      ...formData,
    };

    const url = `${process.env.REACT_APP_API_URL}/updateProfile?userGuid=${decodedToken.userGuid}`;
    const response = await axios.put(url, formDataToSend, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      dispatch({
        type: "UPDATE_NOTIFICATION_SUCCESS",
        payload: "Notifications Updated",
      });
      dispatch(fetchNotificationSettings())
    }
  } catch (error) {
    //console.error("Error updating notification settings:", error);
    dispatch({
      type: "UPDATE_NOTIFICATION_ERROR",
      payload: "Error updating notification settings",
    });
  }
};
